<template>
  <div class="wt2-color-picker wt2-sg">
    <component :is="'type-' + type" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import typeFull from './types/type-full.vue';

export default {
  inheritAttrs: false,

  components: {
    typeFull,
  },

  props: {
    type: {
      type: String,
      default: 'full',
      validator(value) {
        return ['full'].includes(value);
      },
    },
  },
};
</script>
